
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/party-rental",
      function () {
        return require("private-next-pages/party-rental/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/party-rental"])
      });
    }
  